import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
// Components for Each Section
const BrandOverview = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [brandOverview, setBrandOverview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchBrandOverview = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-overview/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setBrandOverview(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchBrandOverview();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handlebrandOverviewChange = (e) => {
        const { name, value } = e.target;
        setBrandOverview((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-overview/${brandOverview.brand_overview_id}/${brandId}`,
                brandOverview,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchBrandOverview();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Brand Overview
                        <small className="text-danger d-block mt-1" style={{ fontSize: '12px' }}>
                            Last Update: {brandOverview?.updatedAt ? new Date(brandOverview.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Brand Name:</th>
                                <td>
                                    {brandOverview?.brand_name}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Tagline/Slogan:</th>
                                <td>
                                    {brandOverview?.tagline}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Industry & Category:</th>
                                <td>
                                    {brandOverview?.industry}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Brand Story <small className="d-block">(Short Summary):</small></th>
                                <td>
                                    {brandOverview?.brandStory}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Mission</th>
                                <td>
                                    {brandOverview?.missionStatement}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Vision</th>
                                <td>
                                    {brandOverview?.visionStatement}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Core Values</th>
                                <td>
                                    {brandOverview?.coreValues}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Key Differentiators  <small className="d-block">(What makes this brand unique?):</small></th>
                                <td>
                                    {brandOverview?.keyDifferentiators}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Competitor Brands:</th>
                                <td>
                                    {brandOverview?.competitorBrands}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Overview"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Brand Name</Form.Label>
                        <Form.Control type="text" value={brandOverview?.brand_name} disabled />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Tagline/Slogan</Form.Label>
                        <Form.Control type="text" name="tagline" value={brandOverview?.tagline || ""} onChange={handlebrandOverviewChange} />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Industry</Form.Label>
                        <Form.Control type="text" name="industry" value={brandOverview?.industry || ""} onChange={handlebrandOverviewChange} />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Category</Form.Label>
                        <Form.Control type="text" name="category" value={brandOverview?.category || ""} onChange={handlebrandOverviewChange} />
                    </Col>
                    <Col md={12} className="mb-3 px-1">
                        <Form.Label>Brand Story</Form.Label>
                        <Form.Control as="textarea" rows={4} name="brandStory" value={brandOverview?.brandStory || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Mission Statement</Form.Label>
                        <Form.Control as="textarea" rows={4} name="missionStatement" value={brandOverview?.missionStatement || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Vision Statement</Form.Label>
                        <Form.Control as="textarea" rows={4} name="visionStatement" value={brandOverview?.visionStatement || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Core Values</Form.Label>
                        <Form.Control as="textarea" rows={5} name="coreValues" value={brandOverview?.coreValues || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Key Differentiators</Form.Label>
                        <Form.Control as="textarea" rows={4} name="keyDifferentiators" value={brandOverview?.keyDifferentiators || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Competitor Brands</Form.Label>
                        <Form.Control as="textarea" rows={4} name="competitorBrands" value={brandOverview?.competitorBrands || ""} onChange={handlebrandOverviewChange} className="h-auto" />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default BrandOverview;